import React, { useRef } from 'react';
import { message } from 'antd';
import FormCard from 'pages/NewUniProfile/components/FormCard';
import TimezoneOperationhours from 'components/Calendar/TimezoneOperationhours';
import { IproviderAvailabilityList } from 'types/appointmentSetting';
import { SUPPORT_TIME_ZONE } from 'constants/common';
import { transferTimePicker } from 'components/Calendar/DatesOverride/utils';
import { useSwitchedProvider } from '../../SwitchedProviderContext';
import commonS from '../../s.module.less';
import s from './s.module.less';

interface Props {
    initValue?: IproviderAvailabilityList | null;
}

const WorkingHoursCard: React.FC<Props> = ({ initValue }) => {
    const { scheduleToken, providerId, onRefresh } = useSwitchedProvider();
    const timeRef = useRef<{ onUpdate: () => Promise<void> }>(null);

    const handleSave = async () => {
        try {
            await timeRef.current?.onUpdate();
            message.success('Working hours saved');
            onRefresh?.();
        } catch (error) {
            console.error('Form save failed:', error);
        }
    };

    const renderEditing = () => (
        <div className={s.editingContainer}>
            <TimezoneOperationhours
                ref={timeRef}
                autoSave={false}
                scheduleToken={scheduleToken}
                providerId={providerId}
            />
        </div>
    );

    const renderReview = () => {
        if (!initValue || !initValue.week?.length) return <div>Not provided</div>;

        const { timezone, week } = initValue;
        const weekData = week?.filter((item) => item.hourFromTo?.length);

        const weekOrder: Record<string, number> = {
            sunday: 0,
            monday: 1,
            tuesday: 2,
            wednesday: 3,
            thursday: 4,
            friday: 5,
            saturday: 6,
        };

        const sortedWeekData = weekData?.sort((a, b) => {
            const orderA = weekOrder[a.weekDay?.toLowerCase() || ''] ?? 7;
            const orderB = weekOrder[b.weekDay?.toLowerCase() || ''] ?? 7;
            return orderA - orderB;
        });

        return (
            <div className={commonS.displayItem}>
                <div className={commonS.label}>Timezone</div>
                <div className={commonS.value}>
                    {SUPPORT_TIME_ZONE.find((item) => item.dictKey === timezone)?.label}
                </div>
                <div className={s.workingHoursList}>
                    {sortedWeekData.map((hour, index) => (
                        <div key={index} className={s.workingHourItem}>
                            <span className={commonS.value}>
                                {hour.weekDay!.charAt(0).toUpperCase() + hour.weekDay!.slice(1)}
                            </span>
                            <span className={commonS.value}>
                                {hour.hourFromTo?.map((item, i) => (
                                    <div key={i}>{transferTimePicker(item)}</div>
                                ))}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <FormCard type="review" title="Working hours" hasContent onSave={handleSave}>
            {(isEditing) => (isEditing ? renderEditing() : renderReview())}
        </FormCard>
    );
};

export default WorkingHoursCard;
